import { trailerAllowed } from '@/lib/ageGate'
import type { ContentCard } from '@/lib/catalog'
import { el, setClass, setText } from '@/lib/dom'
import { queueImage, mediaUrl } from '@/lib/images'
import { T } from '@/lib/i18n'
import type { RemoteKey } from '@/lib/keys'
import { IS_BROWSER } from '@/lib/platform'
import { authStatus } from '@/lib/session'
import { startMutedTrailer } from '@/lib/trailer'

/**
 * ═══════════════════════════════════════════════════════════════════════════
 * FİLMİN SONLUQ EKRANI — YOUTUBE MODELİ (veb TV · LG · Tizen)
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * Sahib tələbi (2026-08-21): «film bitəndən sonra ekranda youtube kimi film
 * önəriləri və rating üçün sağ küncdə ulduzlar 15 saniyəlik görünümü və bu
 * film bitməzdən 30 san öncə başlamalıdır (fallback)».
 *
 * ⚠⚠ ƏVVƏLKİ VARİANT KÜNC KARTI İDİ və sahib onu rədd etdi («youtube modeli …
 *    indi etdiyin sik günündədir»). YouTube-un son ekranı KÜNC QUTUSU DEYİL:
 *    kadrın üstünü tutan, BƏRABƏR ÖLÇÜLÜ və EYNİ 16:9 nisbətli kartlardan
 *    ibarət şəbəkədir. İndi burada da elədir — dörd kart eyni ölçüdə, eyni
 *    nisbətdə; reytinq isə şəbəkənin ALTINDA (2026-08-22 tələbi: «ətraflı
 *    button yerində olsun sağ küncdə yox»).
 *
 * ⚠⚠ CSS GRID VƏ flex-`gap` İŞLƏDİLMİR: build `chrome53`-ə yığılır
 *    (`apps/tv/PERFORMANCE.md`) — hər ikisi orada yoxdur və maket dağılardı.
 *    Şəbəkə `inline-block` + faiz eni ilə, 16:9 nisbəti isə `padding-top: 56.25%`
 *    ilə qurulur (`aspect-ratio` da Chrome 53-də yoxdur).
 *
 * ⚠⚠ TREYLER YALNIZ FOKUSDAKI XANADA VƏ YALNIZ VEB TV-DƏ (veb TV) OYNAYIR.
 *
 *    Sahib tələbi 2026-08-23: «önərilən filmlərin hover itemdəki kimi playeri
 *    loop kimi görünsün heç nə etmədən». «Hover item» məhz veb TV-dəki kartdır və
 *    orada da öngörünüm HƏMİŞƏ BİRDİR (`ui/cardPreview.ts` · `browser/ui.ts` →
 *    `stopActivePreview`). Burada da eynidir: qat açılanda fokus onsuz da
 *    birinci xanadadır, yəni istifadəçi «heç nə etmədən» treyleri görür; fokus
 *    tərpənəndə öngörünüm onunla birlikdə köçür.
 *
 *    ⚠⚠ CİHAZ BUILD-İNDƏ (Tizen · webOS) OYNAMIR və bu, ölçülmüş qadağadır:
 *       qat filmin sonuna 30 saniyə qalmış açılır, yəni FİLM HƏLƏ DEKOD OLUNUR.
 *       İkinci dekoder açmaq TV mühərriklərində donma səbəbidir («canlı dekoder
 *       ≤ 1» qaydası, `apps/tv/PERFORMANCE.md` §4) — orada xanalarda 16:9 KADR
 *       şəkli qalır.
 *
 * ⚠ 16:9 KADR SEÇİLİR (`backdropUrl`), afişa yalnız EHTİYATDIR: bütün xanalar
 *   eyni nisbətdə olmalıdır — qarışıq nisbət məhz sahibin şikayət etdiyi
 *   «dartılmış boş sütunlar» görüntüsünü yaradırdı.
 */

/** Reytinq bloku ekranda neçə ms qalır — sahib tələbi «15 saniyəlik görünüm». */
const VISIBLE_MS = 15000

/** Qiymət veriləndən sonra «təşəkkür» neçə ms görünür. */
const THANKS_MS = 900

/** Ulduz şkalası — server CHECK-i 1..10-dur, sayt və Android TV-də də onluqdur. */
const RATING_MAX = 10

/** Şəbəkədə neçə xana — saytda da dörddür. */
const CARD_LIMIT = 4

/** Kadrın çəkiləcəyi en (px) — CDN-dən məhz bu ölçü istənilir. */
const THUMB_WIDTH = 480

/**
 * Fokus xanada neçə ms qaldıqdan sonra treyler istənir.
 *
 * ⚠ RƏQƏM `ui/cardPreview.ts`-dəkinin EYNİSİDİR və orada ölçülüb: pult
 *   avtotəkrarında addımlar arası ≥90 ms olur (PERFORMANCE.md §2), yəni 150 ms
 *   süzülmə zamanı HEÇ BİR xananın sorğu atmasına imkan vermir.
 */
const PREVIEW_DELAY_MS = 150

/** Öngörünüm pəncərəsi — kataloq kartındakı ilə eyni: «5-ci → 10-cu saniyə». */
const PREVIEW_FROM_SECONDS = 5
const PREVIEW_TO_SECONDS = 10

export interface WatchOutroOptions {
  /** Qiymət veriləcək kontent. `null` olanda ulduzlar ÇƏKİLMİR (treyler yolu). */
  contentId: string | null
  /** «Oxşar» siyahısı — film modalının cavabından gəlir, ƏLAVƏ SORĞU YOXDUR. */
  similar: ContentCard[]
  /** Oxşar seçildi — çağıran oynatmanı bağlayıb həmin filmi açır. */
  onOpenSimilar: (item: ContentCard) => void
  /** Vaxt bitdi və ya qiymət verildi — çağıran qatı söndürür. */
  onFinished: () => void
}

export interface WatchOutro {
  node: HTMLElement
  /** `true` = düymə burada udulub, player-in qalan məntiqinə getməməlidir. */
  onKey(key: RemoteKey): boolean
  destroy(): void
}

export function createWatchOutro(options: WatchOutroOptions): WatchOutro {
  const node = el('div', 'player__outro')

  const items = options.similar.slice(0, CARD_LIMIT)
  const showStars = !!options.contentId

  /**
   * Fokus vəziyyəti: 0-cı sıra təkliflər, 1-ci sıra ulduzlar.
   *
   * ⚠ FOKUS TƏKLİFLƏRDƏN BAŞLAYIR (əvvəl ulduzlardan başlayırdı): ekranın ƏSAS
   *   məzmunu artıq təkliflərdir — YouTube-da da fokus «növbəti video»dadır.
   *   Təklif yoxdursa fokus ulduzlara düşür ki, pult ölü nöqtəyə düşməsin.
   */
  let row = items.length > 0 ? 0 : 1
  let cardIndex = 0
  let starIndex = 0
  let rated: number | null = null
  let closed = false
  let expireTimer: number | null = null
  let thanksTimer: number | null = null

  /** Fokusdakı xananın treyleri (yalnız veb TV — izah faylın başındadır). */
  let previewTimer = 0
  let previewIndex = -1
  let previewStop: (() => void) | null = null
  let previewVideo: HTMLVideoElement | null = null

  /*
    ⚠ «FİLM BİTDİ» BAŞLIĞI YOXDUR (sahib tələbi 2026-08-22: «film bitti sözünə
      də gərək yoxdur»). Ekranın nə olduğu onsuz da aydındır — film dayanıb,
      üstündə təkliflər var.
  */

  // ── Təkliflər şəbəkəsi ──────────────────────────────────────────────────
  const cards: HTMLElement[] = []
  /** Xananın 16:9 çərçivəsi — öngörünüm videosu MƏHZ ora qoyulur. */
  const frames: HTMLElement[] = []
  if (items.length > 0) {
    /*
      ⚠ AYRICA SARĞI (`player__outro-main`) — sahib tələbi 2026-08-23: «önərilən
        filmlər biraz mərkəzə gəlsin». Sarğı stildə şaquli mərkəzə oturur; reytinq
        isə qatdan mütləq mövqe ilə ayrılıb sol-aşağı küncə keçdi, yəni artıq
        şəbəkəni yuxarı itələmir.
    */
    const main = el('div', 'player__outro-main')
    main.appendChild(el('div', 'player__outro-label', T('Bunu da izləyin')))
    const grid = el('div', 'player__outro-grid')
    for (let i = 0; i < items.length; i++) {
      const item = items[i] as ContentCard
      const card = el('div', 'player__outro-card')

      // 16:9 çərçivə — nisbət `padding-top` ilə saxlanılır (izah faylın başında).
      const frame = el('div', 'player__outro-frame')
      const img = el('img', 'player__outro-thumb') as HTMLImageElement
      const source = item.backdropUrl || item.posterUrl
      // ⚠ `queueImage` — TV-də eyni anda çoxlu şəkil çəkmək dekoderi boğur;
      //   növbə app-ın hər yerində işlədilən ortaq qaydadır.
      if (source) queueImage(img, mediaUrl(source, THUMB_WIDTH))
      frame.appendChild(img)
      /*
        ⚠ MƏTN DEYİL, PLAY İKONU (sahib tələbi 2026-08-22: «filmlərin üstünə
          klikdə play işarəsi olsun izlə sözü ilə yox»). Yalnız fokusdakı
          xanada görünür — CSS `.is-focused` ilə idarə olunur.
        ⚠ MƏTN SİMVOLU (▶) İŞLƏDİLİR, SVG YOX: köhnə TV mühərriklərində sətiraltı
          SVG bəzən ölçüsüz çəkilir; simvol isə şrift qatındadır və həmişə çıxır.
      */
      const play = el('div', 'player__outro-play', '▶')
      frame.appendChild(play)
      card.appendChild(frame)

      card.appendChild(el('div', 'player__outro-card-title', item.title))
      if (item.year) card.appendChild(el('div', 'player__outro-card-meta', String(item.year)))

      grid.appendChild(card)
      cards.push(card)
      frames.push(frame)
      if (IS_BROWSER) {
        card.onclick = (event: MouseEvent) => {
          event.stopPropagation()
          if (closed) return
          options.onOpenSimilar(item)
        }
      }
    }
    main.appendChild(grid)
    node.appendChild(main)
  }

  // ── Reytinq — ŞƏBƏKƏNİN ALTINDA ─────────────────────────────────────────
  const stars: HTMLElement[] = []
  let ratingBox: HTMLElement | null = null
  let ratingTitle: HTMLElement | null = null
  let barTrack: HTMLElement | null = null
  let barFill: HTMLElement | null = null

  if (showStars) {
    /*
      ⚠ SOL AŞAĞI KÜNC (sahib tələbi 2026-08-23: «rating sol küncə aşağı
        çəkilsin»). 2026-08-22-də blok şəbəkənin ALTINDA idi və şəbəkəni yuxarı
        itələyirdi; ondan əvvəl SAĞ küncdə idi. Mövqe stildədir — burada yalnız
        qatın birbaşa övladıdır ki, mütləq mövqe qata görə hesablansın.
    */
    ratingBox = el('div', 'player__outro-rating')
    ratingTitle = el('div', 'player__outro-label', T('Bu filmi qiymətləndirin'))
    ratingBox.appendChild(ratingTitle)

    const starRow = el('div', 'player__outro-stars')
    for (let i = 1; i <= RATING_MAX; i++) {
      const star = el('div', 'player__outro-star', '★')
      starRow.appendChild(star)
      stars.push(star)
      if (IS_BROWSER) bindStarClick(star, i)
    }
    ratingBox.appendChild(starRow)

    barTrack = el('div', 'player__outro-bar')
    barFill = el('div', 'player__outro-bar-fill')
    barTrack.appendChild(barFill)
    ratingBox.appendChild(barTrack)
    node.appendChild(ratingBox)

    /*
      Zolaq bir kadr sonra hərəkətə başlayır: eyni kadrda həm `scaleX(1)`, həm
      keçid təyin etsək brauzer başlanğıc dəyəri «heç vaxt olmamış» sayır və
      zolaq ANİ sıfırlanır (köhnə WebKit-də ölçülmüş klassik hal).
    */
    barFill.style.transform = 'scaleX(1)'
    window.setTimeout(() => {
      if (closed || !barFill) return
      barFill.style.transition = 'transform ' + VISIBLE_MS + 'ms linear'
      barFill.style.transform = 'scaleX(0)'
    }, 32)

    /*
      ⚠ VAXT BİTƏNDƏ YALNIZ REYTİNQ İTİR, BÜTÜN EKRAN YOX (saytdakı eyni qərar):
        sayım «qiymət vermək istəmirsənsə keç» deməkdir, «təklifləri götür» yox.
        Əvvəlki künc variantında bütün qat bağlanırdı — indi təkliflər qalır.
    */
    expireTimer = window.setTimeout(() => {
      expireTimer = null
      hideRating()
      if (row === 1) {
        row = cards.length > 0 ? 0 : 1
        paint()
      }
    }, VISIBLE_MS)
  }

  paint()

  function bindStarClick(star: HTMLElement, value: number): void {
    star.onclick = (event: MouseEvent) => {
      event.stopPropagation()
      if (closed) return
      rate(value)
    }
  }

  /** Fokus halqasını və dolu ulduzları yazır — DOM yenidən qurulmur. */
  function paint(): void {
    for (let i = 0; i < cards.length; i++) {
      setClass(cards[i] as HTMLElement, 'is-focused', row === 0 && i === cardIndex)
    }
    for (let i = 0; i < stars.length; i++) {
      const star = stars[i] as HTMLElement
      setClass(star, 'is-focused', row === 1 && i === starIndex)
      // Qiymət verilibsə dolu ulduzlar dəyərə qədər, verilməyibsə fokusa qədər
      // (istifadəçi neçə verəcəyini basmadan görür — TV-də ölçülmüş tələb).
      const upTo = rated !== null ? rated : row === 1 ? starIndex + 1 : 0
      setClass(star, 'is-filled', i < upTo)
    }
    syncCardPreview()
  }

  /**
   * Fokusdakı xananın treylerini açır/köçürür — YALNIZ veb TV-də.
   *
   * ⚠ EYNİ ANDA BİR VİDEO: köhnəsi yenisi başlamazdan ƏVVƏL dayandırılır
   *   («canlı dekoder ≤ 1», PERFORMANCE.md §4). Cihaz build-ində funksiya ilk
   *   sətirdə qayıdır — orada film hələ dekod olunur.
   */
  function syncCardPreview(): void {
    if (!IS_BROWSER) return
    if (closed || row !== 0 || cards.length === 0) {
      stopCardPreview()
      return
    }
    if (previewIndex === cardIndex && (previewStop || previewTimer)) return

    stopCardPreview()
    const asked = cardIndex
    previewIndex = asked
    previewTimer = window.setTimeout(() => {
      previewTimer = 0
      if (closed || row !== 0 || cardIndex !== asked) return
      beginCardPreview(asked)
    }, PREVIEW_DELAY_MS)
  }

  function beginCardPreview(index: number): void {
    const item = items[index]
    const frame = frames[index]
    if (!item || !frame) return
    // Yaş qapısı — 18+ treyler yaşı çatmayana oynamır (kataloq kartındakı qayda).
    // 2026-10-25: `trailerAllowed` (saytla eyni) — girişsiz baxan və profil həddi də nəzərə alınır.
    if (!trailerAllowed(item.ageLimit)) return

    const media = document.createElement('video')
    media.className = 'player__outro-video'
    media.muted = true
    media.setAttribute('playsinline', '')
    /*
      ⚠ ŞƏKİLDƏN SONRA, ▶-DAN ƏVVƏL: ▶ və fokus halqası videonun ÜSTÜNDƏ
        qalmalıdır (veb TV kartındakı eyni sıralama qərarı).
    */
    frame.insertBefore(media, frame.children[1] || null)
    previewVideo = media

    /*
      ⚠ DÖVRƏ `timeupdate` İLƏDİR, `loop` ATRİBUTU İLƏ YOX: `loop` BÜTÖV treyleri
        təkrarlayardı; sahibin istədiyi isə kataloq kartındakı qısa parçadır
        («hover itemdəki kimi»).
    */
    media.addEventListener(
      'timeupdate',
      () => {
        if (!previewVideo) return
        if (previewVideo.currentTime >= PREVIEW_TO_SECONDS) {
          previewVideo.currentTime = PREVIEW_FROM_SECONDS
        }
      },
      false,
    )

    /*
      ⚠⚠ BAŞLANĞIC NÖQTƏSİ YALNIZ BİR DƏFƏ QOYULUR (2026-09-07-də ölçüldü).
         NƏ ÖLÇÜLDÜ (yerli veb TV, Playwright, canlı Mux): sonluq qatında fokusdakı
         xananın treyleri OYNAMIRDI — `currentTime` 14 saniyə boyunca dəqiq 5.0-də
         dondu, `readyState` 1 (yalnız metadata), `paused=false`, şəbəkədə isə EYNİ
         Mux seqmenti dönə-dönə istənirdi (516, 517, 518, 519 …).
         ƏVVƏL NƏ OLURDU: `startMutedTrailer`-in «ilk kadr» geri çağırışı həm
         `loadeddata`, həm də `playing` hadisəsindən gəlir (`lib/trailer.ts`) və
         qoruyucusu YOXDUR. Axtarış (`currentTime = 5`) yeni `loadeddata` doğurur,
         o da yenidən 5-ə atır — sonsuz axtarış-buferləmə dövrəsi. Ekranda donmuş
         kadr, arxada isə fasiləsiz trafik qalırdı.
         NİYƏ MƏHZ BU HƏLL: dövrənin qırılması üçün BİR bayraq bəsdir; `timeupdate`
         ilə qurulan 5→10 saniyə pəncərəsi (yuxarıda) toxunulmur, yəni təkrarlanma
         məntiqi olduğu kimi qalır.
    */
    let seeded = false
    previewStop = startMutedTrailer(
      media,
      null,
      item.slug,
      () => {
        if (!previewVideo) return
        if (!seeded && previewVideo.duration > PREVIEW_FROM_SECONDS + 0.5) {
          seeded = true
          previewVideo.currentTime = PREVIEW_FROM_SECONDS
        }
        previewVideo.className = 'player__outro-video is-ready'
      },
      /*
        ⚠ SÖNDÜRMƏ NÖVBƏYƏ SALINIR: `startMutedTrailer` bu geri çağırışı hələ
          QAYITMAMIŞ (mənbə tapılmayanda) işlədə bilər — o an `previewStop` hələ
          mənimsədilməyib və birbaşa təmizləmə köhnə istinadı buraxardı.
      */
      () => window.setTimeout(stopCardPreview, 0),
    )
  }

  function stopCardPreview(): void {
    if (previewTimer) {
      window.clearTimeout(previewTimer)
      previewTimer = 0
    }
    previewIndex = -1
    if (previewStop) {
      previewStop()
      previewStop = null
    }
    if (previewVideo && previewVideo.parentNode) {
      previewVideo.parentNode.removeChild(previewVideo)
    }
    previewVideo = null
  }

  function hideRating(): void {
    if (ratingBox) ratingBox.style.display = 'none'
  }

  function stopCountdown(): void {
    if (expireTimer !== null) {
      clearTimeout(expireTimer)
      expireTimer = null
    }
    // Donmuş zolaq «nəsə ilişdi» kimi oxunur — tamam gizlədilir.
    if (barTrack) barTrack.style.display = 'none'
  }

  /**
   * Qiymət göndərilir.
   *
   * ⚠ XƏTA UDULUR: şəbəkə xətası üçün ekranı tutmaq qiymətdən daha pisdir
   *   (saytda və Android TV-də eyni qərar). Qiymət film səhifəsindən yenidən
   *   verilə bilər.
   */
  function rate(value: number): void {
    if (rated !== null || !options.contentId) return
    rated = value
    stopCountdown()
    if (ratingTitle) setText(ratingTitle, T('Təşəkkür edirik'))
    paint()

    void authStatus('/api/me/ratings', {
      method: 'PUT',
      body: JSON.stringify({ itemId: options.contentId, value }),
    }).catch(() => undefined)

    // Qısa təşəkkürdən sonra yalnız REYTİNQ yığılır; təkliflər ekranda qalır.
    thanksTimer = window.setTimeout(() => {
      thanksTimer = null
      if (closed) return
      hideRating()
      row = cards.length > 0 ? 0 : 1
      paint()
    }, THANKS_MS)
  }

  return {
    node,

    onKey(key: RemoteKey): boolean {
      if (closed) return false

      /*
        ⚠ İSTİFADƏÇİ TOXUNANDA SAYĞAC DAYANIR: 15 saniyə «heç nə etməyənə»
          verilən vaxtdır. Ulduzlar arasında gəzən adamın bloku əlindən çıxsa,
          bu, birbaşa itirilmiş qiymətdir (özəlliyin bütün məqsədi elə odur).
      */
      if (key === 'up' || key === 'down' || key === 'left' || key === 'right') {
        if (expireTimer !== null) stopCountdown()
      }

      if (key === 'left') {
        if (row === 0) cardIndex = Math.max(0, cardIndex - 1)
        else starIndex = Math.max(0, starIndex - 1)
        paint()
        return true
      }
      if (key === 'right') {
        if (row === 0) cardIndex = Math.min(cards.length - 1, cardIndex + 1)
        else starIndex = Math.min(stars.length - 1, starIndex + 1)
        paint()
        return true
      }
      if (key === 'down') {
        // Aşağı = reytinq blokuna (o, ekranın ALTINDADIR).
        if (row === 0 && stars.length > 0 && ratingBox && ratingBox.style.display !== 'none') {
          row = 1
          paint()
        }
        return true
      }
      if (key === 'up') {
        if (row === 1 && cards.length > 0) {
          row = 0
          paint()
        }
        return true
      }
      if (key === 'enter') {
        if (row === 0 && cards.length > 0) options.onOpenSimilar(items[cardIndex] as ContentCard)
        else if (row === 1 && stars.length > 0) rate(starIndex + 1)
        return true
      }
      /*
        ⚠ GERİ = EKRANI BAĞLA, PLAYER-DƏN ÇIX YOX: qatı görmək istəməyən adam
          filmin son saniyələrindən də məhrum olmamalıdır. Növbəti Geri onsuz da
          player-dən çıxarır (qat artıq yoxdur).
      */
      if (key === 'back') {
        options.onFinished()
        return true
      }
      // Oynat/dayandır, sarıma və s. player-in öz məntiqinə keçir.
      return false
    },

    destroy(): void {
      closed = true
      stopCardPreview()
      if (expireTimer !== null) clearTimeout(expireTimer)
      if (thanksTimer !== null) clearTimeout(thanksTimer)
      expireTimer = null
      thanksTimer = null
      if (node.parentNode) node.parentNode.removeChild(node)
    },
  }
}
